import './index.css';
//Router,
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';
//, useState, useRef, useEffect
import React, { Fragment } from "react";

import TopMenu from './components/TopMenu';
import MenuInicio from './components/MenuInicio';
import MenuCaracteristicas from './components/MenuCaracteristicas';
import MenuPlanesPrecios from './components/MenuPlanesPrecios';
import MenuPreguntas from './components/MenuPreguntas';
import MenuContacto from './components/MenuContacto';

//import logo from './images/LOGO marketBiz-02.png'

import FooterContact from './components/FooterContact';

function App() {
  const navigate = useNavigate();

  const navitageTopMenu = (BtnInfoMenu) => {
    switch (BtnInfoMenu) {
      case 'Inicio':
        navigate('/', { replace: true });
        break;
      case 'Caracteristicas':
        navigate('/Caracteristicas', { replace: true });
        break;
      case 'Planes y Precios':
        navigate('/Planes y Precios', { replace: true });
        break;
      case 'Preguntas Frecuentes':
        navigate('/Preguntas Frecuentes', { replace: true });
        break;
      case 'Contacto':
        navigate('/Contacto', { replace: true });
        break;
      default:
        console.warn('Opción no manejada:', BtnInfoMenu);
    }
  } 

  function FunInicio(){
    var topmenu = <TopMenu navigateTopMenu={navitageTopMenu}/>
    return <div className="transparent-component">
        {topmenu}
        <div className="content">
          <MenuInicio/>
          <FooterContact/>
        </div>
      </div>
  }

  function FunCaracteristicas(){
    var topmenu = <TopMenu navigateTopMenu={navitageTopMenu}/>
    return <div className="transparent-component">
        {topmenu}
        <div className="content">
          <MenuCaracteristicas/>
          <FooterContact/>
        </div>
      </div>
  }

  function FunPlanesPrecios(){
    var topmenu = <TopMenu navigateTopMenu={navitageTopMenu}/>
    return <div className="transparent-component">
        {topmenu}
        <div className="content-width">
          <MenuPlanesPrecios/>
          <FooterContact/>
        </div>
      </div>
  }

  function FunContacto(){
    var topmenu = <TopMenu navigateTopMenu={navitageTopMenu}/>
    return <div className="transparent-component">
        {topmenu}
        <div className="content">
          <MenuContacto/>
        </div>
      </div>
  }

  function FunPreguntas(){
    var topmenu = <TopMenu navigateTopMenu={navitageTopMenu}/>
    return <div className="transparent-component">
        {topmenu}
        <div className="content">
          <MenuPreguntas/>
          <FooterContact/>
        </div>
      </div>
  }

  return (
      <Routes>
        <Route path="/" element={<FunInicio />} />
        <Route path="/Caracteristicas" element={<FunCaracteristicas />} />
        <Route path="/Planes y Precios" element={<FunPlanesPrecios />} />
        <Route path="/Preguntas Frecuentes" element={<FunPreguntas />} />
        <Route path="/Contacto" element={<FunContacto />} />
      </Routes>
  );
}

export default App;
